/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable max-len */
/* eslint-disable-next-line max-len */
import React, {
  useEffect,
  useState,
  useContext,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/mui/dist/Typography';
import Accordion from '@digital-hig/mui/dist/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import styled from 'styled-components';
import EnvContext from '../common/envContext';
import {
  styleVariables,
  ENVIRONMENT,
} from '../common/constants';
import { pushEvent } from '../common/analyticsApi';
import {
  generateCuratedListInfo,
  generateTutorialInfo,
} from '../common/userUtils';
import {
  hasFetchedLearningRecords,
  getLearningRecords,
  isAuthChecked,
  getUserId,
} from '../store/userSlice';

const TranscriptData = ({
  transcriptData, player, videoId, curatedData, tutorialData,
}) => {
  const playerRef = player;

  const [tutorialInfo, setTutorialInfo] = useState(null);
  const [curatedInfo, setCuratedInfo] = useState(null);
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const authChecked = useSelector(isAuthChecked);
  const learningRecords = useSelector(getLearningRecords);
  const recordChecked = useSelector(hasFetchedLearningRecords);
  const uid = useSelector(getUserId);
  const transcriptPanelRef = useRef(null);
  const [refValue, setRefValue] = useState(null);

  useEffect(() => {
    if (transcriptPanelRef.current) {
      setRefValue(transcriptPanelRef.current);
    }
  }, [transcriptPanelRef.current]);

  useEffect(() => {
    const tutorialInfoData = generateTutorialInfo({ tutorialData, learningRecords, env });
    setTutorialInfo(tutorialInfoData);

    if (curatedData) {
      const curatedInfoData = generateCuratedListInfo({ curatedData, learningRecords, env });
      setCuratedInfo(curatedInfoData);
    }
  }, [authChecked, recordChecked, uid]);

  useEffect(() => {
    const videoPlayerRef = playerRef.current;
    const rightPanelRef = refValue;
    const adjustLeftPanelHeight = () => {
      if (videoPlayerRef && rightPanelRef) {
        rightPanelRef.style.height = `${videoPlayerRef.clientHeight}px`;
      }
    };
    window.addEventListener('resize', adjustLeftPanelHeight);
    adjustLeftPanelHeight();

    return () => {
      window.removeEventListener('resize', adjustLeftPanelHeight);
    };
  }, [playerRef, refValue]);

  const analyticsOnTimeStamp = (timeStamp) => {
    const event = {
      eventData: {
        eventName: 'link_click',
      },
      link: {
        linkSection: `Transcript for ${videoId}`,
        linkTitle: timeStamp,
      },
    };
    event.tutorialInfo = tutorialInfo.tutorialInfo;
    if (curatedInfo) {
      event.curatedListInfo = curatedInfo.curatedListInfo;
    }
    pushEvent({ event });
  };

  const millisToMinutesAndSeconds = (millis) => {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return `${(minutes < 10 ? '0' : '')}${minutes}:${(seconds < 10 ? '0' : '')}${seconds}`;
  };

  const jumpToTime = (evt) => {
    const { start } = evt.target.dataset;
    playerRef.current.currentTime = start / 1000;
    playerRef.current.play();
    analyticsOnTimeStamp(millisToMinutesAndSeconds(start));
  };

  const BuildTranscriptData = () => (
    transcriptData.map((d) => (
      <div key={d.start}>
        <Typography variant="short-copy-small" data-start={d.start} onClick={jumpToTime} className="time">{millisToMinutesAndSeconds(d.start)}</Typography>
        <Typography variant="short-copy-small" data-start={d.start} onClick={jumpToTime} className="data">{d.part}</Typography>
      </div>
    ))
  );

  return (
    <RootElement>
      <div className="m-transcript-data">
        <Accordion className="course-module-outline" dense variant="individualPanel">
          <AccordionSummary>
            <Typography variant="headline-smaller">Transcript</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="transcript-data-container">
              <div className="transcript-data">
                <BuildTranscriptData />
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      <div className="dt-transcript-data">
        <div className="transcript-data-container" ref={transcriptPanelRef}>
          <div className="transcription-header">
            <Typography variant="button-label">
              Video transcript
            </Typography>
          </div>
          <div className="transcript-data">
            <BuildTranscriptData />
          </div>
        </div>
      </div>
    </RootElement>
  );
};

const RootElement = styled.div`
.m-transcript-data{
  display: none;
}
.transcript-data-container {
    display: flex;
    flex-direction: column;

      .transcript-data {
        overflow: scroll;
        margin-top: 10px;
        background-color: ${ styleVariables.backgroundPanelColor };
        padding: 20px;
        font-size: 14px;
        text-align: left;
        flex-grow: 2;
        
        .time {
          margin: 0 0 3px 0;
          text-decoration: underline;
          cursor: pointer;
        }
        .data{
          margin-bottom: 15px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            text-decoration-color: ${styleVariables.fillEngage};
          }
        }
      }

      .transcription-header {
        h3 {
          font-size: 21px;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .m-transcript-data{
      display: block;
      padding-left: 0.25rem!important;
    }
    .dt-transcript-data{
      display: none;
    }
    .transcript-data-container {
      height: auto;
      .transcript-data {
        padding: 0;
        background: none;
        overflow: visible;
      } 
    }
  }
  @media screen and (min-width: 601px) and (max-width: 1039px) {
    .dt-transcript-data{
      padding-left: 0.25rem!important;
    }
  }
  @media screen and (min-width: 1040px) {
    .dt-transcript-data{
      padding-left: 1.25rem!important;
    }
  }
`;

TranscriptData.propTypes = {
  player: PropTypes.string,
  transcriptData: PropTypes.arrayOf(PropTypes.shape({})),
  videoId: PropTypes.string,
  curatedData: PropTypes.shape({}),
  tutorialData: PropTypes.shape({}),
};

TranscriptData.defaultProps = {
  player: '',
  transcriptData: [],
  videoId: '',
  curatedData: {},
  tutorialData: {},
};

export default React.memo(TranscriptData);
